import React, { useEffect, useRef, useState } from 'react'
import AppLayout                              from '@/Layouts/AppLayout'
import OrganizationLayout                      from '@/Layouts/OrganizationLayout'
import { FactorSettings } from "@/Pages/Organization/FactorSettings";
import { Inertia }                             from "@inertiajs/inertia";
import LayoutIcon from "@/Components/LayoutIcon";
import { Percent } from "@/Icons";
// import { toast } from "react-toastify";

export default function CreateFactor({ errors }) {
  return (
    <FactorSettings errors={errors} onSave={(form) => Inertia.visit('/factors')} />
  )
}

CreateFactor.layout = page => {

  const backAction = () => {
    const backUrl = route('factors');
    const previousUrl = page.props?.previous_url;
    const [previousPath] = previousUrl.split('?');

    if (backUrl === previousPath && window.history.length > 1) {
      window.history.back();
    } else {
      Inertia.visit(backUrl);
    }
  }

  return (
    <AppLayout title="New emission factor">
      <OrganizationLayout
        // factor={page.factor}
        header="New emission factor"
        backAction={{ label: 'Back', callback: backAction }}
        icon={<LayoutIcon><Percent size={40} className="text-black"/></LayoutIcon>}
      >{page}</OrganizationLayout>
    </AppLayout>
  )
}
